import React, { Component } from 'react';
import Button from '../../../Common/VMButton';
import './coupon.scss';
import i18n from '../../../i18n'
class coupon extends Component {
  
    
    render() {
        const {
            couponCodeFromUser,
            onCouponCodeFromUserChanged,
            onRegisterCoupon,
            showInputField,
            showCheckbox
          } = this.props;
        return (
            <div>
                <div className="page-name-small">
                    
                    <form className="payment-coupon-register mobile-payment-flex" style={{display : showInputField ? `flex` : 'none'}} onSubmit={onRegisterCoupon}>
                    <div className="page-name-small-header">{i18n.t("coupon.title")}</div>
                        <div className="register-new-coupon">
                       {i18n.t("coupon.new.register.coupon")}
                        </div>
                        <input
                        className="payment-coupon-input"
                        style={{ flex: '1' }}
                        type="text"
                        placeholder={i18n.t("monsterpoint.input.coupon.number")}
                        value={couponCodeFromUser}
                        onChange={onCouponCodeFromUserChanged}
                        autoComplete="off"
                        />
                        <Button
                        width={this.props.width}
                        height={'30px'}
                        style={{ background: '#8bc541' }}
                        onClick={onRegisterCoupon}
                        >
                        <div style={{ color: '#fff' }}> {i18n.t("monsterpoint.register.text")}</div>
                        </Button>
                    </form>
                </div>
                <div className="coupon-header-container">
                    <div className="coupon-name">{i18n.t("coupon.coupon.name")}</div>
                    <div className="coupon-expiry">{i18n.t("coupon.expiration.date")}</div>
                    <div className="coupon-remain">{i18n.t("coupon.remain.count.title")}</div>
                    {showCheckbox && <div className="coupon-select">{i18n.t("coupon.select")}</div>}
                </div>
            </div>
        );
    }
}

export default coupon;